import { CommandHandlerProvider } from '@/Application/CommandHandlerProvider'
import { SendEncryptedXmlOfferCommandHandler } from '@/Application/XmlOffer'
import { XmlOfferBuilderService } from '@/Domain/XmlOffer/Builder'
import { XmlOfferEncrypterService, EncryptedXmlOfferRepository, PublicKeyRepository } from '@/Domain/XmlOffer/Encrypter'
import { StandardXmlOfferBuilderService } from '@/Infrastructure/XmlOffer'
import { VuexSingleProcedureRepository, VuexProcedureFactory } from '@/Infrastructure/Procedures/Persistence/Vuex'
import { VuexBatchRepository, VuexBatchFactory } from '@/Infrastructure/Batch/Persistence/Vuex'
import { VuexOfferRepository, VuexOfferFactory } from '@/Infrastructure/Offer/Persistence/Vuex'
import { StandardXmlOfferEncrypterService } from '@/Infrastructure/XmlOffer/StandardXmlOfferEncrypterService'
import { AxiosEncryptedXmlOfferRepository, JsonEncryptedXmlOfferSerializer } from '@/Infrastructure/XmlOffer/Persistence/Axios'
import { InMemoryEncryptedXmlOfferRepository } from '@/Infrastructure/XmlOffer/Persistence/InMemory'
import { AxiosApiClient } from '@/Infrastructure/ApiClient'
import { SessionTokenStorage } from '@/Infrastructure/Account/SessionTokenStorage'
import { InMemoryPublicKeyRepository } from '@/Infrastructure/XmlOffer/Encrypter/Persistence/InMemory'
import { AxiosPublicKeyRepository } from '@/Infrastructure/XmlOffer/Encrypter/Persistence/Axios'

export class SendEncryptedXmlOfferCommandHandlerProvider implements CommandHandlerProvider<SendEncryptedXmlOfferCommandHandler> {
  provide (): SendEncryptedXmlOfferCommandHandler {
    const xmlOfferBuilder = this.provideXmlOfferBuilder()
    const xmlOfferEncrypter = this.provideXmlOfferEncrypter()
    const xmlOfferRepository = this.provideXmlOfferRepository()
    const procedureRepository = new VuexSingleProcedureRepository(
      new VuexProcedureFactory()
    )
    return new SendEncryptedXmlOfferCommandHandler(
      xmlOfferBuilder,
      xmlOfferEncrypter,
      xmlOfferRepository,
      procedureRepository
    )
  }

  private provideXmlOfferBuilder (): XmlOfferBuilderService {
    return new StandardXmlOfferBuilderService(
      new VuexSingleProcedureRepository(new VuexProcedureFactory()),
      new VuexBatchRepository(new VuexBatchFactory()),
      new VuexOfferRepository(new VuexOfferFactory())
    )
  }

  private provideXmlOfferEncrypter (): XmlOfferEncrypterService {
    const repository = this.providePublicKeyRepository()
    return new StandardXmlOfferEncrypterService(repository)
  }

  private provideXmlOfferRepository (): EncryptedXmlOfferRepository {
    if (process.env.VUE_APP_API_ENV === 'local') {
      return new InMemoryEncryptedXmlOfferRepository()
    }
    return new AxiosEncryptedXmlOfferRepository(
      new AxiosApiClient(new SessionTokenStorage()),
      new JsonEncryptedXmlOfferSerializer()
    )
  }

  private providePublicKeyRepository (): PublicKeyRepository {
    if (process.env.VUE_APP_API_ENV === 'local') {
      return new InMemoryPublicKeyRepository()
    }
    return new AxiosPublicKeyRepository(
      new AxiosApiClient(new SessionTokenStorage())
    )
  }
}
